import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../services/api';

const DebugPage: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  const testTokenValidation = async () => {
    try {
      console.log('Testing token validation...');
      const response = await authAPI.validateToken();
      console.log('Token validation response:', response.data);
      alert('Token validation successful!');
    } catch (error) {
      console.error('Token validation failed:', error);
      alert('Token validation failed!');
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Debug Page
      </Typography>
      
      <Typography variant="h6" gutterBottom>
        Authentication State
      </Typography>
      
      <Box mb={2}>
        <Typography>Loading: {isLoading ? 'Yes' : 'No'}</Typography>
        <Typography>Authenticated: {isAuthenticated ? 'Yes' : 'No'}</Typography>
        <Typography>User: {user ? `${user.name} (${user.email})` : 'None'}</Typography>
      </Box>

      <Box mb={2}>
        <Typography variant="h6" gutterBottom>
          LocalStorage
        </Typography>
        <Typography>Token: {localStorage.getItem('token') ? 'Present' : 'Missing'}</Typography>
        <Typography>User: {localStorage.getItem('user') ? 'Present' : 'Missing'}</Typography>
      </Box>

      <Button variant="contained" onClick={testTokenValidation}>
        Test Token Validation
      </Button>
    </Box>
  );
};

export default DebugPage;
